import React from 'react';
import { Link } from 'react-router-dom';

function GuideCard({ guide }) {
  return (
    <Link to={`/guides/${guide.slug}`} className="guide-card">
      <h3 className="guide-card-title">{guide.title}</h3>
      <p className="guide-card-description">{guide.description}</p>
      <div className="guide-card-meta">
        <span className="guide-category">{guide.category}</span>
        <span className="guide-difficulty">{guide.difficulty}</span>
        <span className="guide-time">{guide.estimatedTime}</span>
      </div>
    </Link>
  );
}

export default GuideCard;
